import Vue from "vue";
import { canRatePuzzle } from "js/crossword/ratingStore";
import { Provider } from "js/crossword/types";
import PopupButtons from "./PopupButtons";
import PuzzleRating from "./PuzzleRating";
import PopupContainer from "./PopupContainer";

import styles from "../css/PausePopup.module.css";
declare const sdkHandler: any;

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    puzzleId: String,
  },
  data() {
    return {
      ratingPossible: canRatePuzzle(this.puzzleId),
      ratingOpened: false,
    };
  },
  render() {
    return (
      <PopupContainer customClasses={[styles.container]}>
        { !this.ratingOpened ?
          <div>
            <div class={styles.messageWrapper}>
              <img class={styles.pauseIcon} src="images/Coffee_Icon.svg" />
              <div>
                {this.localization.get("Your puzzle is")} <b>{this.localization.get("paused")}</b>.
                </div>
            </div>
            <PopupButtons buttons={[{
              label: this.localization.get("Resume"),
              onClick: () => sdkHandler.trigger('interstitialAd', { callback: function() {
                this.$emit("close");
              }}, this),
            }]} />
          </div> : null}

        { this.ratingPossible
          ? <PuzzleRating
            puzzleId={this.puzzleId}
            onOpenRating={() => { this.ratingOpened = true; }}
            onCloseRating={() => { this.ratingOpened = false; }}
            onClosePopup={() => { this.$emit("close"); }} />
          : null}
      </PopupContainer>
    );
  },
});